import React, { useState, useEffect, useLayoutEffect, useContext } from 'react';
import { Typography } from '@mui/material';
import LicensingBoardsLanding from './LicensingBoardsLanding';
import LeftNavMenu from '../common/Navbar';
import '../../styles/Unclaimed-CME-Dashboard.css';
import { userContext } from '../../context/userContext';
import { useHistory } from 'react-router-dom';

const ManageRequirements: React.FC = () => {
  const history = useHistory();

  // Get user context
  const userObject = useContext(userContext);
  const userData = userObject.User;

  // Navigation and height management
  const [height, setHeight] = useState(0);
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  // Check if user is admin, redirect if not
  useEffect(() => {
    if (userData.acepMemberStatus !== 2) {
      history.push('/');
    }
  }, [userData.acepMemberStatus, history]);

  useLayoutEffect(() => {
    const el = document.body.getElementsByClassName('HomePagebackground')[0];
    if (!el) return;

    const updateHeight = () => {
      setHeight(el.clientHeight + 120);
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return (
    <div className='UnclaimedDashboard HomePagebackground adminView'>
      <div className="HomePageWrapper">
        <div style={{float:'left',width:'5%'}}>
          <LeftNavMenu member={1} heightDashboardPage={height} onCollapse={(isNavExpanded: any) => {
            setIsNavExpanded(isNavExpanded);
          }} />
        </div>

        <div className={isNavExpanded ? 'Right-Div-Dashboard-expanded overlay' : 'Right-Div-individual-Dashboard'}>
          {/* Header */}
          <div className="AdminDashboard-Heading">
            Manage CME Requirements
          </div>

          {/* Licensing Boards Landing Page (includes State Medical Board & Medical Specialty Board tabs) */}
          <LicensingBoardsLanding />
        </div>
      </div>
    </div>
  );
};

export default ManageRequirements;
